import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
    title: 'KSE Solutions - Projektleitung, Bauleitung & Engineering Schweiz | St. Gallen'
  },
  {
    path: 'datenschutz',
    loadComponent: () => import('./pages/privacy/privacy.component').then(m => m.PrivacyComponent),
    title: 'Datenschutz - KSE Solutions'
  },
  {
    path: 'impressum',
    loadComponent: () => import('./pages/impressum/impressum.component').then(m => m.ImpressumComponent),
    title: 'Impressum - KSE Solutions'
  },
  {
    path: 'netzbau',
    loadComponent: () => import('./pages/netzbau/netzbau.component').then(m => m.NetzbauComponent),
    title: 'Netzbau St. Gallen & Ostschweiz | Energie- & Versorgungsnetze | KSE Solutions'
  },
  {
    path: 'systemtechnik',
    loadComponent: () => import('./pages/systemtechnik/systemtechnik.component').then(m => m.SystemtechnikComponent),
    title: 'Systemtechnik St. Gallen | Automation, Engineering & BSA | KSE Solutions'
  },
  {
    path: 'ueber-uns',
    loadComponent: () => import('./pages/about/about.component').then(m => m.AboutComponent),
    title: 'Über uns - KSE Solutions GmbH | Ingenieurbüro St. Gallen'
  },
  {
    path: 'kontakt',
    loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent),
    title: 'Kontakt - KSE Solutions | Projektleitung & Engineering Beratung'
  },
  {
    path: '**',
    redirectTo: ''
  }
];
